"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FriendsEditor = void 0;
// TODO: Implement FriendsEditor
const react_1 = __importStar(require("react"));
const users_1 = require("./users");
class FriendsEditor extends react_1.Component {
    constructor(props) {
        super(props);
        this.render = () => {
            return react_1.default.createElement("div", null,
                react_1.default.createElement("h2", null, "Check those users who are your friends:"),
                react_1.default.createElement("ul", null, this.renderUsersList()),
                react_1.default.createElement("p", null, "Those users will see some information about your schedule."));
        };
        this.renderUsersList = () => {
            const list = [];
            for (const user of users_1.USERS) {
                if (user === this.props.user) {
                    continue;
                }
                list.push(react_1.default.createElement("li", null,
                    user + " ",
                    react_1.default.createElement("button", { value: user, onClick: this.doToggleFriendClick }, this.doIsFriendClick(user) ? "Unfriend" : "Friend")));
            }
            return list;
        };
        this.doIsFriendClick = (name) => {
            if (this.props.friends === undefined) {
                return false;
            }
            for (const user of this.props.friends) {
                if (user === name) {
                    return true;
                }
            }
            return false;
        };
        this.doToggleFriendClick = (evt) => {
            const user = evt.currentTarget.value;
            const cur = this.props.friends === undefined ? [] : this.props.friends;
            const newFriends = this.doIsFriendClick(user) ? cur.filter((f) => f !== user) : cur.concat([user]);
            this.props.setFriends(newFriends);
        };
        this.state = { newFriend: "" };
    }
}
exports.FriendsEditor = FriendsEditor;
//# sourceMappingURL=data:application/json;base64,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